import { feeProviderPricingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const FEE_PROVIDER_TYPE = createNamedActions('feeProvider', {
  GET_PROVIDERS: 'GET_PROVIDERS',
  CREATE_PROVIDER: 'CREATE_PROVIDER',
  UPDATE_PROVIDER: 'UPDATE_PROVIDER',
  DELETE_PROVIDER: 'DELETE_PROVIDER',
});

const feeProviderViewSchema = new schema.Entity('data', {}, { idAttribute: 'feeProviderId' });

export const getFeeProvidersAction = catchAsyncActionError((params = {}) => async dispatch => {
  const { data } = await feeProviderPricingApi.getFeeProviders(params);

  return dispatch({
    type: FEE_PROVIDER_TYPE.GET_PROVIDERS,
    payload: normalize(data, [feeProviderViewSchema]).entities.data,
  });
});

export const createFeeProviderAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await feeProviderPricingApi.createFeeProvider(params);

  return dispatch({
    type: FEE_PROVIDER_TYPE.CREATE_PROVIDER,
    payload: data,
  });
});

export const updateFeeProviderAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await feeProviderPricingApi.updateFeeProvider(params);

  return dispatch({
    type: FEE_PROVIDER_TYPE.UPDATE_PROVIDER,
    payload: data,
  });
});

export const deleteFeeProviderAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await feeProviderPricingApi.deleteFeeProvider(params);

  return dispatch({
    type: FEE_PROVIDER_TYPE.DELETE_PROVIDER,
    payload: data,
    meta: params,
  });
});
